import React from 'react'

interface AdminFeaturesIconProps {
  className?: string
  isActive?: boolean
}

export const AdminFeaturesIcon: React.FC<AdminFeaturesIconProps> = ({ 
  className = '', 
  isActive = false 
}) => {
  return (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4ZM10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10Z" 
        fill={isActive ? "#3B82F6" : "white"}
      />
      <path 
        d="M10 13C7.33 13 5 15.33 5 18H15C15 15.33 12.67 13 10 13Z" 
        fill={isActive ? "#3B82F6" : "white"}
      />
    </svg>
  )
} 